import { PAYMENT_EVENTS } from '../common/constants/paymentEvents';
import type { AnalyticsEventName } from '../types/events';

export function withSubscriptionService(
  event: AnalyticsEventName,
  props: Record<string, unknown>,
  subscriptionService: string,
): Record<string, unknown> {
  if (!PAYMENT_EVENTS.has(event)) return props;

  return { ...props, subscription_service: subscriptionService };
}
